import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Flex } from 'foundations-components/components/Flex';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { MainContentHeader } from '../components/MainContentHeader';
import { SubscriptionsCard } from '../components/Subscriptions/SubscriptionsCard';
import { useSubscriptionsData } from '../hooks/useSubscriptionsData';
import { trackPageView } from '../utils/usageTracker';
import { Paths } from '../constants/Paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SubscriptionsPage = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const showPaymentMethodUpdated = params.get('paymentMethodUpdated') === 'true';
  const {
    loading,
    data: subscriptions
  } = useSubscriptionsData();
  useEffect(() => {
    trackPageView('subscriptions-overview');
  }, []);
  useEffect(() => {
    if (showPaymentMethodUpdated) {
      FloatingAlertStore.addAlert({
        message: unescapedText('subscriptions.paymentMethodUpdated'),
        type: 'success'
      });
      history.replace(Paths.SUBSCRIPTIONS);
    }
  }, [showPaymentMethodUpdated, history]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "SUBSCRIPTIONS_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsx(MainContentLayout, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "700",
        flexGrow: 1,
        children: [/*#__PURE__*/_jsx(MainContentHeader, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.title"
          })
        }), /*#__PURE__*/_jsx(SubscriptionsCard, {
          subscriptions: subscriptions,
          loading: loading
        })]
      })
    })
  });
};